import {
  DashboardMenuIcon,
  PriceEstimationMenuIcon,
  ClipboardIcon,
  ClaimingAgentMenuIcon,
  CodingAutomatorMenuIcon,
  CPTGuidelineMenuIcon,
  DntMenuIcon,
  DoctorFeeMenuIcon,
  EvaluationMenuIcon,
  InsuranceMenuIcon,
  InvoiceMenuIcon,
  ServiceClassMenuIcon,
  SurgeryRoomMenuIcon,
  MedicalToolsMenuIcon,
  BoxIcon,
  UsersIcon,
  UserIcon,
  ClockIcon,
  PerforationSurgeryMenuIcon,
  BriefcaseIcon,
  BookOpenIcon,
  BoxMenuIcon,
  KlaimTPAIcon,
  BuildingIcon,
  ChecklistVerifiedIcon,
  // UserCheckIcon,
} from 'shared/ui/icons';
import { Permission } from 'shared/constants/permission';

export const menuGroupList = [
  {
    id: 1,
    api_id: 1,
    name: '',
    cascade: false,
  },
  {
    id: 2,
    api_id: 32,
    name: 'Patient',
    nameKey: 'menu_group_patient',
    cascade: true,
  },
  {
    id: 3,
    api_id: 33,
    name: 'Insurance',
    nameKey: 'menu_group_insurance',
    cascade: true,
  },
  {
    id: 4,
    api_id: 35,
    name: 'Master Data',
    nameKey: 'menu_group_master_data',
    cascade: true,
  },
  {
    id: 5,
    api_id: 36,
    name: 'Managements',
    nameKey: 'menu_group_managements',
    cascade: true,
  },
];

export const menuListRole = [
  // {
  //   menu_id: 0, // blm di sesuaikan ID nya
  //   name: 'Dashboard',
  //   icon: <DashboardMenuIcon />,
  //   can_create: false,
  //   can_read: false,
  //   can_update: false,
  //   can_delete: false,
  //   menu_group_id: 1,
  //   show: true,
  // },

  {
    menu_id: 99,
    name: 'Policy Overview',
    nameKey: 'menu_policy_overview',
    icon: <ClipboardIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  }, // mock menu
  {
    menu_id: 2,
    name: 'Prior Authorization',
    nameKey: 'menu_prior_authorization',
    icon: <ClipboardIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 31,
    name: 'Price Estimation',
    nameKey: 'menu_price_estimation',
    icon: <PriceEstimationMenuIcon color="#9ca3af" />,
    menu_group_id: 1,
    child_menu: [
      {
        menu_id: 3,
        menu_parent_id: 31,
        name: 'Surgery',
        nameKey: 'menu_surgery',
        can_create: false,
        can_read: false,
        can_update: false,
        can_delete: false,
      },
      {
        menu_id: 4,
        menu_parent_id: 31,
        name: 'Non Surgery',
        nameKey: 'menu_non_surgery',
        can_create: false,
        can_read: false,
        can_update: false,
        can_delete: false,
      },
    ],
    show: true,
  },
  {
    menu_id: 5,
    name: 'Evaluation',
    nameKey: 'menu_evaluation',
    icon: <EvaluationMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 6,
    name: 'Doctor Notes Transcriptor',
    nameKey: 'menu_dnt',
    icon: <DntMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 7,
    name: 'Coding Automator',
    nameKey: 'menu_coding_automator',
    icon: <CodingAutomatorMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  // {
  //   menu_id: 7,
  //   name: 'Eligibility Verificator', // ga ada di API dan SIDEBAR figma
  //   icon: <UserCheckIcon />,
  //   can_create: false,
  //   can_read: false,
  //   can_update: false,
  //   can_delete: false,
  //   menu_group_id: 1,
  //   show: false,
  // },
  {
    menu_id: 8,
    name: 'Claiming Agent',
    nameKey: 'menu_claiming_agent',
    icon: <ClaimingAgentMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 9,
    name: 'Invoice',
    nameKey: 'menu_invoice',
    icon: <InvoiceMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 10,
    name: 'CPT Guideline',
    nameKey: 'menu_cpt_guideline',
    icon: <CPTGuidelineMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 1,
    show: true,
  },
  {
    menu_id: 11,
    name: 'Patients',
    nameKey: 'menu_patients',
    icon: <UsersIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 2,
    show: true,
  },
  {
    menu_id: 12,
    name: 'Medical Records',
    nameKey: 'menu_medical_records',
    icon: <ClipboardIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 2,
    show: true,
  },
  {
    menu_id: 13,
    name: 'Insurance Portal',
    nameKey: 'app_insurance_portal',
    icon: <InsuranceMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    can_approve: false,
    can_read_all: false,
    menu_group_id: 3,
    show: true,
  },
  {
    menu_id: 34,
    name: 'Approver Dashboard',
    nameKey: 'menu_approver_dashboard',
    icon: <DashboardMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 3,
    show: true,
  },
  {
    menu_id: 1,
    name: 'Buku Tarif',
    nameKey: 'menu_buku_tarif',
    icon: <BookOpenIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 3,
    show: true,
  },
  {
    menu_id: 14,
    name: 'Service Class',
    nameKey: 'menu_service_class',
    icon: <ServiceClassMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 15,
    name: 'Doctor Fee',
    nameKey: 'menu_doctor_fee',
    icon: <DoctorFeeMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 16,
    name: 'Doctor',
    nameKey: 'menu_doctor',
    icon: <UserIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 17,
    name: 'Surgery Room Rent',
    nameKey: 'menu_surgery_room_rent',
    icon: <SurgeryRoomMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 18,
    name: 'Medicine and Disposable',
    nameKey: 'menu_medicine_and_disposable',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 19,
    name: 'Medical tools',
    nameKey: 'menu_medical_tools',
    icon: <MedicalToolsMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 20,
    name: 'Surgery Hours',
    nameKey: 'menu_surgery_hours',
    icon: <ClockIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 21,
    name: 'Perforation Surgery',
    nameKey: 'menu_perforation_surgery',
    icon: <PerforationSurgeryMenuIcon color="#9ca3af" />, // lanjut disini
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 22,
    name: 'ICD-MM (Maternal Mortality)',
    nameKey: 'menu_icd_mm',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 23,
    name: 'ICD-PM (Perinatal Mortality)',
    nameKey: 'menu_icd_pm',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 24,
    name: 'Morphology (ICD-O-3 2nd Revision)',
    nameKey: 'menu_morphology',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 25,
    name: 'Topography (ICD-O)',
    nameKey: 'menu_topography',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 26,
    name: 'ICD-9CM e-klaim',
    nameKey: 'menu_icd_9cm',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 27,
    name: 'ICD-10CM e-klaim',
    nameKey: 'menu_icd_10cm',
    icon: <BoxIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 4,
    show: true,
  },
  {
    menu_id: 28,
    name: 'User',
    nameKey: 'menu_user',
    icon: <UserIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 5,
    show: true,
  },
  {
    menu_id: 29,
    name: 'Role',
    nameKey: 'menu_role',
    icon: <BriefcaseIcon color="#9ca3af" />, // lanjut disini
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 5,
    show: true,
  },
  {
    menu_id: 99001,
    name: 'Company',
    nameKey: 'menu_company',
    icon: <BuildingIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 5,
    show: true,
  },
  // SUPER-ADMIN
  {
    menu_id: 45,
    name: 'Buku Tarif',
    nameKey: 'menu_buku_tarif',
    icon: <BookOpenIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    show: false,
  },
  {
    menu_id: 46,
    name: 'Insurance Claim',
    nameKey: 'menu_insurance_claim',
    icon: <InsuranceMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    show: false,
  },
  {
    menu_id: 51,
    name: 'Riwayat Klaim',
    nameKey: 'menu_riwayat_klaim',
    icon: <BoxMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    show: true,
  },
  {
    menu_id: 52,
    name: 'Klaim TPA',
    nameKey: 'menu_klaim_tpa',
    icon: <KlaimTPAIcon color="#9ca3af" stroke="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 3,
    show: true,
    supportedPermissions: [Permission.READ],
  },
  {
    menu_id: 59,
    name: 'Quality Checker',
    nameKey: 'menu_quality_checker',
    icon: <ChecklistVerifiedIcon width="18" height="18" color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    can_approve: false,
    can_read_all: false,
    menu_group_id: 3,
    show: true,
  },
  {
    menu_id: 58,
    name: 'Dashboard Analitik',
    nameKey: 'app_analytics_dashboard',
    icon: <DashboardMenuIcon color="#9ca3af" />,
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
    menu_group_id: 3,
    show: true,
    supportedPermissions: [Permission.READ],
  },
];
